
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Settings, Zap } from "lucide-react";

export const IntegrationsHeader = () => {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center space-y-0 pb-2">
        <div className="flex items-center gap-2">
          <Zap className="h-6 w-6 text-blue-600" />
          <div>
            <CardTitle className="text-2xl font-bold">Integrações</CardTitle>
            <CardDescription>
              Conecte sua aplicação com serviços externos para automatizar processos
            </CardDescription>
          </div>
        </div>
        <Settings className="ml-auto h-5 w-5 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          Configure e gerencie as integrações com serviços externos para expandir as funcionalidades da sua aplicação.
        </p>
      </CardContent>
    </Card>
  );
};
